export const Resources = {    
    SubscribeAriaLabel: 'Subscriviu-vos aquí per rebre les darreres notícies i/o les notes de premsa del ministeri',
    BellGreetingLogged: 'Hola ',
    BellGreeting: 'Hola!',
    BellText01: 'Potser us interessa la subscripció a les següents',
    BellText02: 'La subscripció es vincularà a l\'adreça electrònica següent',
    BellText03: 'Si desitgeu modificar-ho, ho podeu fer editant les dades de l\'usuari',

    SubscribeTitle: 'Subscriu-te',
    SubscribeTitleUperCase: 'SUBSCRIU-TE',
    SubscribeBtnTitle: 'Subscriu-te a les Newsletters del Ministeri',
    LoginSignUpUperCase: 'REGISTRA\'T',
    SubscriptionsManagerUperCase: 'GESTIÓ DE SUBSCRIPCIONS',
    
    Cancel: 'Cancel·lar',
    Ok: 'Ok',

    SendActivationMailButton: 'Enviar email d\'activació',
    SendActivationMailOK: 'Email enviat correctament al correu proporcionat.',
    SendActivationMailError: 'Error en enviar el missatge. Per favor, intenti-ho de nou més tard.',
    
    LoginAuthentication: 'Identifica\'t',
    LoginRecoverPass: 'Recuperar contrasenya',
    LoginSignUpText: 'Si encara no tens compte',   
    LoginButton: 'Botó Identifica\'t', 

    ToolTipCheckBell: 'Per eliminar la subscripció heu d\'anar a la gestió de subscripcions',
    EnterEmail: 'Introduïu la vostra adreça electrònica',
    EnterPass: 'Introduïu la vostra contrasenya',

    RecoveryAccountModal: 'S\'enviarà un correu de recuperació de contrasenya a l\'adreça electrònica indicada',
    RecoveryAccountModalMailSended: 'Si l\'adreça està registrada, rebreu un correu electrònic a la safata d\'entrada',

    //--------- Mensajes de Error -------------
    // SecurityPasswordChange: ServiceMessage1
    // InvalidCredentials: ServiceMessage3    
    // MailInUse: ServiceMessage4
    // DocInUso: ServiceMessage5
    // SendActivationEmailError: ServiceMessage6
    // SendRecoveryEmailError: ServiceMessage7
    // InvalidToken: ServiceMessage8
    // InternalServiceError: ServiceMessage9
    // GenerateJWTNoUser: ServiceMessage10
    // NoGroupId: ServiceMessage11
    // NoAuthenticated: ServiceMessage12
    // NoActiveUser: ServiceMessage13
    // NewActivationTokenError: ServiceMessage14
    // UserNoExist: ServiceMessage16

    ServiceMessage1: 'Hem millorat el sistema de seguretat per accedir a les seves subscripcions, per això és necessari canviar la contrasenya. Pot fer-ho des de el apartat de "Recuperar Contrasenya".',
    ServiceMessage2: '',
    ServiceMessage3: 'No existeix un compte associat a el email indicat o la contrasenya és incorrecta.',
    ServiceMessage4: 'El correu electrònic proporcionat es troba en ús.',
    ServiceMessage5: 'Document de identitat en ús.',
    ServiceMessage6: 'Usuari creat correctament. Error en enviar  el email de activació de usuari.',
    ServiceMessage7: 'Error en enviar  el email de recuperació de usuari.',
    ServiceMessage8: 'L\'identificador és incorrecte o ha expirat. Si sou un usuari nou, haureu de registrar-vos.',
    ServiceMessage9: 'Error intern de el servei.',
    ServiceMessage10: 'No es pot recuperar el usuari.',
    ServiceMessage11: 'Es ha produït un error en la obtenció de les publicacions de el usuari. Per favor, si el problema persisteix, contacti amb el servei tècnic.',
    ServiceMessage12: 'Cap usuari amb sessió activa.',
    ServiceMessage13: 'El usuari encara no ha activat el compte.',
    ServiceMessage14: 'Error en generar  un nou codi de activació.',
    ServiceMessage15: '',
    ServiceMessage16: 'No existeix un compte associat a el email indicat.',
    ServiceMessage17: 'La contrasenya actual no és correcta.',
    ServiceMessage19: "La nova contrasenya no pot ser igual que la contrasenya actual.",
    ServiceMessage21: "Ha de completar el captcha.",

    ServiceMessage503: 'El servei de subscripcions no es troba disponible, per favor, intenti-ho més tarda. Disculpi les molèsties.',
    
    ErrorCode0: 'Ok',
    ErrorCode1: 'El correu electrònic no pot estar vacio',
    ErrorCode2: 'El correu electrònic és erroni',
    ErrorCode3: 'La contrasenya no pot estar vacia',
    ErrorCode4: 'S\'ha de seleccionar almenys una subscripció',
    ErrorCode5: 'Ha de completar el captcha',
    ErrorCode6: 'La contrasenya triada no és suficientment segura/segura. Ha de tenir almenys 8 caràcters, majúscules, minúscules, nombres i símbols. Els símbols admesos són: _!@#$%^&*.-',
}